<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="طابعة MB2236 المتعددة الوظائف">
     طابعة MB2236 المتعددة الوظائف
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ar" title="معلومات السلامة">
     معلومات السلامة
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href=".html#d0e23" title="مصطلحات متفق عليها">
      مصطلحات متفق عليها
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="safety-cable-topic.html#d0e42" title="بيانات عن المنتج">
      بيانات عن المنتج
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ar" title="التعرّف على الطابعة">
     التعرّف على الطابعة
    </a>
   </p>
   <div id="divd0e172">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ar" title="العثور على معلومات عن الطابعة">
      العثور على معلومات عن الطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_ar" title="العثور على الرقم التسلسلي للطابعة">
      العثور على الرقم التسلسلي للطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configured-model-topic.html#configured-model_ar" title="تهيئة الطابعة">
      تهيئة الطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-control-panel-group.html#d0e379" title="استخدام لوحة التحكم">
      استخدام لوحة التحكم
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_ar" title="تخصيص الشاشة الرئيسية">
      تخصيص الشاشة الرئيسية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="changing-language-of-onscreen-keyboard-topic.html#changing-language-of-onscreen-keyboard_ar" title="تغيير لغة لوحة المفاتيح على الشاشة">
      تغيير لغة لوحة المفاتيح على الشاشة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ar" title="فهم حالة زر الطاقة وضوء المؤشر">
      فهم حالة زر الطاقة وضوء المؤشر
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="selecting-paper-group.html#d0e759" title="تحديد نوع الورق">
      تحديد نوع الورق
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ar" title="الإعداد والتثبيت والتهيئة">
     الإعداد والتثبيت والتهيئة
    </a>
   </p>
   <div id="divd0e1613">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_ar" title="تحديد موقع للطابعة">
      تحديد موقع للطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="attaching-cables-topic.html#attaching-cables_ar" title="توصيل الكبلات">
      توصيل الكبلات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="setting-up-printer-to-fax-group.html#d0e1808" title="إعداد الطابعة للإرسال عبر الفاكس">
      إعداد الطابعة للإرسال عبر الفاكس
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_ar" title="تهيئة إعدادات SMTP للبريد الإلكتروني">
      تهيئة إعدادات SMTP للبريد الإلكتروني
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="loading-paper-and-specialty-media-group.html#d0e3741" title="تحميل الورق والوسائط الخاصة">
      تحميل الورق والوسائط الخاصة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="installing-printer-software-topic.html#d0e3874" title="تثبيت البرامج وبرامج التشغيل والبرامج الثابتة وتحديثها">
      تثبيت البرامج وبرامج التشغيل والبرامج الثابتة وتحديثها
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e4107" title="شبكة الاتصال">
      شبكة الاتصال
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_ar" title="إنشاء ملف تعريف في Cloud Connector">
      إنشاء ملف تعريف في Cloud Connector
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_ar" title="طباعة صفحة إعدادات القوائم">
      طباعة صفحة إعدادات القوائم
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ar" title="تأمين الطابعة">
     تأمين الطابعة
    </a>
   </p>
   <div id="divd0e4625">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ar" title="مسح ذاكرة الطابعة">
      مسح ذاكرة الطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ar" title="استعادة إعدادات المصنع الافتراضية">
      استعادة إعدادات المصنع الافتراضية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_ar" title="بيان الذاكرة">
      بيان الذاكرة
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ar" title="الطباعة">
     الطباعة
    </a>
   </p>
   <div id="divd0e4747">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ar" title="الطباعة من كمبيوتر">
      الطباعة من كمبيوتر
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4773" title="الطباعة من جهاز محمول">
      الطباعة من جهاز محمول
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ar" title="الطباعة من محرك أقراص فلاش">
      الطباعة من محرك أقراص فلاش
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_ar" title="أنواع &rlm;-محركات أقراص فلاش- والملفات المدعومة">
      أنواع &rlm;-محركات أقراص فلاش- والملفات المدعومة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ar" title="تهيئة المهام السرية">
      تهيئة المهام السرية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ar" title="طباعة المهام السرية والمهام المحجوزة الأخرى">
      طباعة المهام السرية والمهام المحجوزة الأخرى
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_ar" title="الطباعة من ملف تعريف Cloud Connector">
      الطباعة من ملف تعريف Cloud Connector
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_ar" title="طباعة قائمة عينات الخطوط">
      طباعة قائمة عينات الخطوط
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_ar" title="وضع أوراق فاصلة بين النسخ">
      وضع أوراق فاصلة بين النسخ
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="canceling-print-job-topic.html#canceling-print-job_ar" title="إلغاء مهمة طباعة">
      إلغاء مهمة طباعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ar" title="ضبط &rlm;-قتامة مسحوق الحبر-">
      ضبط &rlm;-قتامة مسحوق الحبر-
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_ar" title="النسخ">
     النسخ
    </a>
   </p>
   <div id="divd0e5367">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ar" title="استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية">
      استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="making-copies-topic.html#making-copies_ar" title="إنشاء النُسخ">
      إنشاء النُسخ
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="copying-photos-topic.html#copying-photos_ar" title="نسخ الصور الفوتوغرافية">
      نسخ الصور الفوتوغرافية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="copying-letterhead-topic.html#copying-letterhead_ar" title="النسخ على الورق ذي الرأسية">
      النسخ على الورق ذي الرأسية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ar" title="النسخ على وجهَي الورقة">
      النسخ على وجهَي الورقة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_ar" title="تصغير أو تكبير النُسخ">
      تصغير أو تكبير النُسخ
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="saving-paper-topic.html#saving-paper_ar" title="طباعة عدة صفحات على ورقة واحدة">
      طباعة عدة صفحات على ورقة واحدة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="collating-copies-topic.html#collating-copies_ar" title="ترتيب النُسخ">
      ترتيب النُسخ
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="copying-cards-topic.html#copying-cards_ar" title="نسخ البطاقات">
      نسخ البطاقات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_ar" title="إنشاء اختصار نسخة">
      إنشاء اختصار نسخة
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="e-mailing-chapter.html#e-mailing-chapter_ar" title="البريد الإلكتروني">
     البريد الإلكتروني
    </a>
   </p>
   <div id="divd0e5697">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-ADF-and-scanner-glass-email-topic.html#using-ADF-and-scanner-glass-email_ar" title="استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية">
      استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="sending-email-topic.html#sending-email_ar" title="إرسال بريد إلكتروني">
      إرسال بريد إلكتروني
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_ar" title="الفاكس">
     الفاكس
    </a>
   </p>
   <div id="divd0e5812">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_ar" title="استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية">
      استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="sending-fax-topic.html#sending-fax_ar" title="إرسال فاكس">
      إرسال فاكس
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="scheduling-fax-topic.html#sending-fax-scheduled-time_ar" title="جدولة فاكس">
      جدولة فاكس
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ar" title="إنشاء اختصار وجهة الفاكس">
      إنشاء اختصار وجهة الفاكس
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_ar" title="تغيير دقة الفاكس">
      تغيير دقة الفاكس
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ar" title="ضبط قتامة الفاكس">
      ضبط قتامة الفاكس
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-fax-log-topic.html#printing-fax-log_ar" title="طباعة سجل فاكس">
      طباعة سجل فاكس
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_ar" title="منع استلام الفاكسات غير المرغوب فيها">
      منع استلام الفاكسات غير المرغوب فيها
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="holding-faxes-topic.html#holding-faxes_ar" title="إيقاف الفاكسات">
      إيقاف الفاكسات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="forwarding-fax-topic.html#forwarding-fax_ar" title="إعادة توجيه الفاكس">
      إعادة توجيه الفاكس
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_ar" title="المسح الضوئي">
     المسح الضوئي
    </a>
   </p>
   <div id="divd0e6206">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_ar" title="استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية">
      استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_ar" title="المسح الضوئي إلى الكمبيوتر">
      المسح الضوئي إلى الكمبيوتر
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ar" title="المسح الضوئي إلى محرك أقراص فلاش">
      المسح الضوئي إلى محرك أقراص فلاش
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_ar" title="المسح الضوئي إلى خادم FTP">
      المسح الضوئي إلى خادم FTP
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_ar" title="جارٍ المسح الضوئي إلى مجلد شبكة">
      جارٍ المسح الضوئي إلى مجلد شبكة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_ar" title="المسح الضوئي إلى ملف تعريف في Cloud Connector">
      المسح الضوئي إلى ملف تعريف في Cloud Connector
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_ar" title="استخدام قوائم الطابعة">
     استخدام قوائم الطابعة
    </a>
   </p>
   <div id="divd0e6553">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_ar" title="خريطة القوائم">
      خريطة القوائم
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="preferences-topic.html#d0e6901" title="جهاز">
      جهاز
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="layout-topic.html#d0e8537" title="الطباعة">
      الطباعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="tray-configuration-topic.html#d0e9329" title="ورق">
      ورق
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="copy-defaults-topic.html#d0e9630" title="النسخ">
      النسخ
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="fax-defaults-subgroup.html#d0e9852" title="الفاكس">
      الفاكس
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="email-setup-topic.html#d0e11474" title="البريد الإلكتروني">
      البريد الإلكتروني
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="ftp-defaults-topic.html#d0e12157" title="بروتوكول FTP">
      بروتوكول FTP
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="flash-drive-scan-topic.html#d0e12589" title="برنامج تشغيل USB">
      برنامج تشغيل USB
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="network-overview-topic.html#d0e13194" title="Network/Ports (شبكة الاتصال/المنافذ)">
      Network/Ports (شبكة الاتصال/المنافذ)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="login-methods-subgroup.html#d0e15209" title="Security (الأمان)">
      Security (الأمان)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_ar" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="menu-settings-page-topic.html#d0e15923" title="Reports (التقارير)">
      Reports (التقارير)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_ar" title="استكشاف الأخطاء وإصلاحها">
      استكشاف الأخطاء وإصلاحها
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ar" title="صيانة الطابعة">
     صيانة الطابعة
    </a>
   </p>
   <div id="divd0e16215">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_ar" title="فحص حالة أجزاء الطباعة ومستلزماتها">
      فحص حالة أجزاء الطباعة ومستلزماتها
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_ar" title="تهيئة إخطارات مستلزمات الطباعة">
      تهيئة إخطارات مستلزمات الطباعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_ar" title="إعداد تنبيهات البريد الإلكتروني">
      إعداد تنبيهات البريد الإلكتروني
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="viewing-reports-topic.html#viewing-reports_ar" title="عرض التقارير">
      عرض التقارير
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="ordering-supplies-group.html#ordering-supplies-group_ar" title="طلب الأجزاء والمستلزمات">
      طلب الأجزاء والمستلزمات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="replacing-toner-cartridge-topic.html#d0e16486" title="استبدال الأجزاء والمستلزمات">
      استبدال الأجزاء والمستلزمات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="cleaning-printer-topic.html#d0e16631" title="تنظيف أجزاء الطابعة">
      تنظيف أجزاء الطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configuring-power-save-mode-settings-topic.html#d0e16719" title="توفير الطاقة والورق">
      توفير الطاقة والورق
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="moving-printer-topic.html#moving-printer_ar" title="تحريك الطابعة إلى موقع آخر">
      تحريك الطابعة إلى موقع آخر
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="shipping-printer-topic.html#shipping-printer_ar" title="شحن الطابعة">
      شحن الطابعة
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ar" title="استكشاف مشكلة وإصلاحها">
     استكشاف مشكلة وإصلاحها
    </a>
   </p>
   <div id="divd0e16879">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="print-quality-problems-topic.html#print-quality-problems_ar" title="مشكلات جودة الطباعة">
      مشكلات جودة الطباعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="print-quality-is-poor-subgroup.html#d0e16990" title="مشاكل الطباعة">
      مشاكل الطباعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_ar" title="الطابعة لا تستجيب">
      الطابعة لا تستجيب
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ar" title="يتعذر قراءة محرك أقراص فلاش">
      يتعذر قراءة محرك أقراص فلاش
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_ar" title="تمكين منفذ USB">
      تمكين منفذ USB
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e19597" title="مشاكل اتصال شبكة الاتصال">
      مشاكل اتصال شبكة الاتصال
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e19815" title="مشاكل المستلزمات">
      مشاكل المستلزمات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="clearing-jams.html#clearing-jams_ar" title="التخلص من انحشار الورق">
      التخلص من انحشار الورق
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="solving-printer-problems.html#solving-printer-problems_ar" title="مشاكل تغذية الورق">
      مشاكل تغذية الورق
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e20593" title="مشاكل البريد الإلكتروني">
      مشاكل البريد الإلكتروني
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-caller-id-not-shown-topic.html#d0e20712" title="مشاكل إرسال الفاكسات">
      مشاكل إرسال الفاكسات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e21367" title="مشاكل المسح الضوئي">
      مشاكل المسح الضوئي
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ar" title="الاتصال بخدمة دعم العملاء">
      الاتصال بخدمة دعم العملاء
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_ar" title="إعادة التدوير والتخلص من المستلزمات">
     إعادة التدوير والتخلص من المستلزمات
    </a>
   </p>
   <div id="divd0e22122">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_ar" title="إعادة تدوير منتجات Lexmark">
      إعادة تدوير منتجات Lexmark
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ar" title="إعادة تدوير مواد تغليف Lexmark">
      إعادة تدوير مواد تغليف Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ar" title="إشعارات">
     إشعارات
    </a>
   </p>
   <div id="divd0e22157">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e22160" title="معلومات عن المنتج">
      معلومات عن المنتج
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e22177" title="إشعار الإصدار">
      إشعار الإصدار
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#trademarks_ar" title="العلامات التجارية">
      العلامات التجارية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#licensing-notices_ar" title="إشعارات الترخيص">
      إشعارات الترخيص
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#noise-emission-levels_ar" title="مستويات انبعاث التشويش">
      مستويات انبعاث التشويش
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#product-disposal_ar" title="التخلص من المنتج">
      التخلص من المنتج
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_ar" title="إرجاع خراطيش Lexmark بغرض إعادة استخدامها أو إعادة تدويرها">
      إرجاع خراطيش Lexmark بغرض إعادة استخدامها أو إعادة تدويرها
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ar" title="إشعار الحساسية للكهرباء الاستاتيكية">
      إشعار الحساسية للكهرباء الاستاتيكية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#energy-star_ar" title="برنامج ENERGY STAR">
      برنامج ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#temperature-information_ar" title="معلومات درجة الحرارة">
      معلومات درجة الحرارة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#laser-notice_ar" title="إشعار الليزر">
      إشعار الليزر
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#power-consumption_ar" title="استهلاك الطاقة">
      استهلاك الطاقة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_ar" title="الإشعارات التنظيمية لمعدات الاتصال الطرفية">
      الإشعارات التنظيمية لمعدات الاتصال الطرفية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e22507" title="الإشعارات التنظيمية الخاصة بالمنتجات اللاسلكية">
      الإشعارات التنظيمية الخاصة بالمنتجات اللاسلكية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#modular-component-notice_ar" title="إشعار المكون النمطي">
      إشعار المكون النمطي
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ar" title="التعرض لإشعاع تردد الراديو">
      التعرض لإشعاع تردد الراديو
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue